'use strict';

exports.__esModule = true;
exports.default = isSafeNumber;
function isSafeNumber(value) {
    return typeof value === 'number' && !isNaN(value) && isFinite(value);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/sono/core/utils/isSafeNumber.js
// module id = 384
// module chunks = 0